<template>
  <div class="box zq-videos">
    <h2 class="box__title" v-translate>{{ title }}</h2>
    <div class="box__content">
      <youtube-video v-for="video in data" :video="video" :key="video.id"/>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import YoutubeVideo from "./YoutubeVideo";

export default {
  name: 'videos',
  components: {YoutubeVideo},
  props: {
    url: String,
    title: String
  },
  data() {
    return {
      'data': [],
    }
  },
  methods: {
    fetchData: async function () {
      this.data = (await axios.get(this.url)).data
    }
  },
  created: function () {
    this.fetchData();
  }
}
</script>